import { Router, ActivatedRoute, ParamMap, NavigationExtras } from '@angular/router';
import { Component, Inject, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { SystemInformationService } from '../_infrastructure/SystemInformation/SystemInformationService';
import { SecurityService } from '../_infrastructure/Security/SecurityService';
import { SessionStorageService } from '../_infrastructure/SessionStorageService/SessionStorageService';

@Component({
    selector: 'confirm-submission',
    templateUrl: './confirm-submission.component.html',
    standalone: false
})

export class ConfirmSubmissionComponent implements OnInit, OnDestroy {

  public subscriberNumber: number;
  public manifestNumber: number;

  public workflowDefinition: models.WorkflowInformationVM = <models.WorkflowInformationVM>{};

  // PIT 40803 \\
  public destinoRouter: string;

  @ViewChild('cgaGetFileForm', { read: ElementRef }) cgaGetFileForm: ElementRef;
  @ViewChild('cgaGetFileFormInput', { read: ElementRef }) cgaGetFileFormInput: ElementRef;
  public domain: string;

  constructor(private changeDetector: ChangeDetectorRef, private http: HttpClient, private activeRoute: ActivatedRoute,
    private router: Router, @Inject(DOCUMENT) private document: Document, private systemInfo: SystemInformationService,
    private securityService: SecurityService, private sessionStorageService: SessionStorageService) {

  }

  ngOnInit(): void {

    // PIT 40803 \\
    const validOption = ['/instancebrowser', '/workflowSearch'];
    const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

    if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
      //const oriValue = JSON.parse(dadosOrigem);

      this.destinoRouter = dadosOrigem.origemDoAcesso;
    }
    else {
      this.destinoRouter = '/workflowSearch';
    }
    // PIT 40803 \\

    this.activeRoute.paramMap.subscribe((params: ParamMap) => {

      this.subscriberNumber = <any>params.get('subscriber');
      this.manifestNumber = <any>params.get('manifest');

      let loggedSubscriber : number = +this.securityService.userDetails.utente?.split(' ')[0];

      if (loggedSubscriber == undefined || loggedSubscriber != this.subscriberNumber) this.handleWrongSubscriber();
      else {
        this.loadWorkflowDetails();
        this.systemInfo.loadCurrentSystemInformation().subscribe(result => {
          this.domain = this.securityService.userDetails.refererDomain + result.fileTransfer;
        });
      }
    });
  }


  //LIFECYCLE
  ngOnDestroy(): void {

  }

  validateManifest() {
    this.router.navigate(['manifest/accept', this.subscriberNumber, this.manifestNumber]);
  }

  rejectManifest() {
    this.router.navigate(['manifest/reject', this.subscriberNumber, this.manifestNumber]);
  }

  public getInstructions() {
    this.cgaGetFileFormInput.nativeElement.value = this.workflowDefinition.workFlowHelpLink;
    this.cgaGetFileForm.nativeElement.action = this.domain;
    this.cgaGetFileForm.nativeElement.submit();
  }

  public loadWorkflowDetails() {
    this.http.post<models.WorkflowInformationVM>('api/WorkflowSearch/GetWorkflowInformation', null, {
      params: {
        subscriberNumber: <any>this.subscriberNumber
      }
    }
    ).subscribe((result) => {
      this.workflowDefinition = result;
    }, error => console.error(error));
  }

  handleWrongSubscriber() {
    const navigationExtras: NavigationExtras = { state: { data: 'WorkflowSearch.InvalidSubscriberManifest', code: 'ER' } };
    this.router.navigate(['workflowSearch'], navigationExtras);
  }
}
